<template> <!-- OK -->
  <div class="player-management">
    <h2>Gerenciamento das Penalidades</h2>
    <div>
      <button @click="goBack" class="back-button">Voltar para Administração</button>
      <button @click="confirmPenalizar" class="penalizar-button">Penalizar</button>
    </div>
    <div class="filter-container">
      <label for="stage">Etapa:</label>
      <select v-model="selectedStageId" @change="fetchPlayers" id="stage">
        <option v-for="stage in stages" :key="stage.id" :value="stage.id">
          {{ stage.name }}
        </option>
      </select>
      <label v-if="controlePenalidade">Penalidade Aplicada</label>
      <label v-else>Penalidade não aplicada</label>
    </div>
    <div class="table-wrapper">
      <table class="player-table">
        <thead>
        <tr>
          <th>Nome</th>
          <th>Jogos Realizados</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="player in sortedPlayers" :key="player.playerId">
          <td :class="{'highlight-green' : player.playedGames >= 3, 'highlight-red': player.playedGames < 3 }">{{ player.fullName }}</td>
          <td>{{ player.playedGames }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <p>{{ modalMessage }}</p>
        <div class="btn-model">
          <button @click="confirmAction" class="confirm-button">Confirmar</button>
          <button @click="cancelAction" class="cancel-button">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import playerService from '../services/playerService';
import stageService from '../services/stageService';

export default {
  name: 'PenalidadesManagement',
  data() {
    return {
      players: [],
      stages: [],
      penalizados: [],
      selectedStageId: null,
      gamesByPlayer: {},
      showModal: false,
      modalMessage: '',
    };
  },
  computed: {
    sortedPlayers() {
      return this.players.slice().sort((a,b) => {
        return a.fullName.localeCompare(b.fullName);
      });
    },
    selectedStage() {
      return this.stages.find(stage => stage.id === this.selectedStageId) || null;
    },
    controlePenalidade(){
      for (const stage of this.stages) {
        if (stage.id === this.selectedStageId){
          return stage.penalidade === true;
        }
      }
    }
  },
  methods: {
    async fetchStages() {
      try {
        const response = await stageService.getAllStages();
        this.stages = response.data;
        if (this.stages.length > 0) {
          this.selectedStageId = this.stages[this.stages.length - 1].id;
        }
      } catch (error) {
        console.error('Erro ao buscar etapas', error);
      }
    },
    async fetchPlayers() {

      try{
        const response = await playerService.getPlayersWithPlayedGames(this.selectedStageId);
        this.players = response.data;
      } catch (error) {
        console.error('Erro ao buscar jogos dos jogadores', error);
      }

    },
    goBack() {
      this.$router.push('/admin');
    },
    confirmPenalizar() {
      if (!this.selectedStage) return;
      console.log(this.selectedStage)
      if (this.selectedStage.penalidade === false){
        this.showModal = true;
        this.modalMessage = 'Tem certeza que deseja aplicar a penalidade?';
        this.actionToConfirm = this.penalizar;
      } else{
        alert("Não é possível aplicar mais de uma penalidade por etapa")
      }
    },
    async penalizar() {
      this.penalizados = [];
      for (const player of this.players) {
        if (player.playedGames < 3)
          this.penalizados.push(player.playerId);
      }
      console.log(this.penalizados);
      await playerService.applyPenalty(this.penalizados);
      await stageService.updatePenalidade(this.selectedStageId);
    },
    confirmAction() {
      if (this.actionToConfirm) {
        this.actionToConfirm();
      }
      alert('Penalidade atribuída com sucesso!');
      this.showModal = false;
    },
    cancelAction() {
      this.showModal = false;
    },
  },
  async created() {
    await this.fetchStages();
    await this.fetchPlayers();
  }
};
</script>

<style scoped>
.player-management {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #F0F4F7;
  padding: 2rem;
}

.player-management h2 {
  margin-bottom: 2rem;
  color: #003366;
  font-size: 2.5rem;
}

.back-button {
  text-decoration: none;
  color: white;
  background-color: #0056B3;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  transition: background-color 0.3s;
  margin-bottom: 1rem;
  margin-right: 1rem;
}

.back-button:hover {
  background-color: #003366;
}

.penalizar-button{
  text-decoration: none;
  color: white;
  background-color: #b30015;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  transition: background-color 0.3s;
  margin-bottom: 1rem;
}

.penalizar-button:hover {
  background-color: #81020e;
}

.highlight-green {
  color: green;
  font-weight: bold;
}

.highlight-red {
  color: red;
  font-weight: bold;
}

.filter-container {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.player-table {
  width: 100%;
  max-width: 1200px;
  border-collapse: collapse;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.player-table th,
.player-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #DDD;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
}

.confirm-button {
  background-color: #28a745;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.confirm-button:hover {
  background-color: #218838;
}

.cancel-button {
  background-color: #e74c3c;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.cancel-button:hover {
  background-color: #c0392b;
}

.btn-model{
  margin-top: 1rem;
}


@media (max-width: 768px) {
  .player-management h2 {
    font-size: 2rem;
  }

  .player-table th,
  .player-table td {
    padding: 0.5rem;
    font-size: 0.9rem;
  }

  .back-button {
    font-size: 0.9rem;
    padding: 0.4rem 0.8rem;
  }

}

@media (max-width: 425px) {
  .player-management h2 {
    font-size: 1.5rem;
    text-align: center;
  }

  .player-table th,
  .player-table td {
    padding: 0.3rem;
    font-size: 0.8rem;
  }

  .back-button {
    font-size: 0.8rem;
    padding: 0.3rem 0.6rem;
  }

}
</style>
